import * as Yup from 'yup';
import piiFormModel from './formModel';

const {
  nameModel,
  addressModel,
  birthDateModel,
  phoneNumberModel,
  ssnModel,
  emailAddressModel,
} = piiFormModel;

const {
  formFields: { first, middle, last, suffix },
} = nameModel;

const {
  formFields: { street1, street2, city, state, zip, country },
} = addressModel;

const {
  formFields: { birthDate },
} = birthDateModel;

const {
  formFields: { phoneNumber },
} = phoneNumberModel;

const {
  formFields: { ssn, confirmSsn },
} = ssnModel;

const {
  formFields: { emailAddress },
} = emailAddressModel;

export const firstNameValidation = Yup.string()
  .min(first.min, first.minErrMsg)
  .max(first.max, first.maxErrMsg)
  .matches(first.matches, first.matchesErrMsg)
  .required(first.requiredErrMsg);

export const middleNameValidation = Yup.string()
  .min(middle.min, middle.minErrMsg)
  .max(middle.max, middle.maxErrMsg)
  .matches(middle.matches, middle.matchesErrMsg)
  .required(middle.requiredErrMsg);

export const lastNameValidation = Yup.string()
  .min(last.min, last.minErrMsg)
  .max(last.max, last.maxErrMsg)
  .matches(last.matches, last.matchesErrMsg)
  .required(last.requiredErrMsg);

export const suffixValidation = Yup.string().oneOf(
  suffix.oneOf,
  suffix.oneOfErrMsg,
);

export const street1Validation = Yup.string()
  .min(street1.min, street1.minErrMsg)
  .max(street1.max, street1.maxErrMsg)
  .matches(street1.matches, street1.matchesErrMsg)
  .required(street1.requiredErrMsg);

export const street2Validation = Yup.string()
  .min(street2.min, street2.minErrMsg)
  .max(street2.max, street2.maxErrMsg)
  .matches(street2.matches, street2.matchesErrMsg)
  .notRequired();

export const cityValidaton = Yup.string()
  .matches(city.matches, city.matchesErrMsg)
  .test('no-hyphen-start-end', city.nonMatchesErrMsg, (value) => {
    return !value || (!value.startsWith('-') && !value.endsWith('-'));
  })
  .min(city.min, city.minErrMsg)
  .max(city.max, city.maxErrMsg)
  .required(city.requiredErrMsg);

export const stateValidation = Yup.string().required(state.requiredErrMsg);

export const zipValidation = Yup.string()
  .matches(zip.matches, zip.matchesErrMsg)
  .length(zip.length, zip.lengthErrMsg)
  .required(zip.requiredErrMsg);

export const countryValidation = Yup.string().required(country.requiredErrMsg);

export const birthDateValidation = Yup.string().required(
  birthDate.requiredErrMsg,
);

export const phoneNumberValidation = Yup.string()
  .matches(phoneNumber.matches, phoneNumber.matchesErrMsg)
  .length(phoneNumber.length, phoneNumber.lengthErrMsg)
  .required(phoneNumber.requiredErrMsg);

export const ssnValidation = Yup.string()
  .length(9, ssn.lengthErrMsg)
  .matches(ssn.matches, ssn.matchesErrMsg)
  .required(ssn.requiredErrMsg);

export const confirmSsnValidation = Yup.string()
  .oneOf([Yup.ref('ssn')], confirmSsn.matchesErrMsg)
  .required(confirmSsn.requiredErrMsg);

export const emailAddressValidation = Yup.string()
  .email(emailAddress.emailErrMsg)
  .max(emailAddress.max, emailAddress.maxErrMsg)
  .matches(emailAddress.matches, emailAddress.matchesErrMsg)
  .required(emailAddress.requiredErrMsg);
